import { IQuery, IQueryMediator } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IAPPlannedCourseGroupDatasource } from '../../global/datasources/ap_planned_course_group_datasource';
import { IAPProgramSlotDatasource } from '../../global/datasources/ap_program_slot_datasource';

export class APPlannedCourseGroupQuery implements IQuery {
  private __result: any;

  constructor(
    QueryMediator: IQueryMediator,
    private ngAPPlannedCourseGroupDatasource: IAPPlannedCourseGroupDatasource,
    private ngAPProgramSlotDatasource: IAPProgramSlotDatasource
  ) {
    QueryMediator.registerQuery(this, ngAPPlannedCourseGroupDatasource);
  }

  run(): this {
    const planned_course_group = this.ngAPPlannedCourseGroupDatasource.read();
    const program_slots = this.ngAPProgramSlotDatasource.read();

    _4.each(planned_course_group, (courseGroup: any) => {
      const programSlotObj = _4.find(program_slots, (programSlot: any) => {
        return programSlot.id === courseGroup.program_slot;
      });
      if (programSlotObj) {
        programSlotObj._course_group_id = courseGroup.id;
        courseGroup._program_slot = programSlotObj;
      }
    });

    this.__result = {
      planned_course_group
    };
    return this;
  }

  get result(): any {
    return this.__result;
  }
}

angular.module('capability-ng-academic-planner').service('ngAPPlannedCourseGroupQuery', APPlannedCourseGroupQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/queries/ap_planned_course_group_query.ts